<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <path
            fill-rule="evenodd"
            d="M8.21 5.23a.75.75 0 0 1 1.06-.02l6.5 6.25a.75.75 0 0 1 0 1.08l-6.5 6.25a.75.75 0 1 1-1.04-1.08L14.168 12 8.23 6.29a.75.75 0 0 1-.02-1.06Z"
            clip-rule="evenodd"
        />
    </svg>
</template>

<script>
export default { name: "ChevronRightIcon" };
</script>
